import moment, { Moment } from 'moment';

export const sortByDate = (
	a: string | Date | Moment | undefined,
	b: string | Date | Moment | undefined,
) => {
	if (!a) {
		return -1;
	}
	if (!b) {
		return 1;
	}

	const momentA = moment(a);
	const momentB = moment(b);

	return momentA.isAfter(momentB) ? 1 : -1;
};
